export async function loadMoreAuthorPosts() {
  // Extracts the author identifier from the URL
  function getAuthorIdentifierFromURL() {
    const urlPath = window.location.pathname;
    const pathSegments = urlPath.split("/");
    const authorSegmentIndex = pathSegments.findIndex(
      (segment) => segment === "author"
    );

    if (
      authorSegmentIndex !== -1 &&
      pathSegments.length > authorSegmentIndex + 1
    ) {
      return pathSegments[authorSegmentIndex + 1];
    }

    return null;
  }

  // Fetches the author's numeric ID using the identifier
  async function fetchAuthorIdByIdentifier(identifier) {
    if (!isNaN(identifier)) {
      return identifier; // Directly return if it's a numeric ID
    }

    try {
      const response = await fetch(
        `https://promotioncentre.co.uk/wp-json/wp/v2/users?slug=${identifier}`
      );
      const users = await response.json();

      if (users.length > 0) {
        return users[0].id;
      } else {
        console.error("No user found with this identifier");
        return null;
      }
    } catch (error) {
      console.error("Error fetching user by identifier:", error);
      return null;
    }
  }

  // Function to decode HTML entities
  function decodeEntities(encodedString) {
    const parser = new DOMParser();
    const dom = parser.parseFromString(
      "<!doctype html><body>" + encodedString,
      "text/html"
    );
    return dom.body.textContent;
  }

  // Main logic for loading posts
  const authorIdentifier = getAuthorIdentifierFromURL();

  const authorId = await fetchAuthorIdByIdentifier(authorIdentifier);

  let currentPage = 1;
  const postsPerPage = 12;
  const postContainerAuthor = document.getElementById("post-container-author");
  const readMoreBtn = document.getElementById("read-more-btn-author");

  let hasLoadedAllPosts = false;
  const excludedPosts = window.excludedPosts || [];

  function getEmbeddedImageUrl(post) {
    const media = post?._embedded?.["wp:featuredmedia"]?.[0];
    return (
      media?.media_details?.sizes?.medium_large?.source_url ||
      media?.media_details?.sizes?.medium?.source_url ||
      media?.source_url ||
      ""
    );
  }

  function getEmbeddedCategoryName(post) {
    const terms = post?._embedded?.["wp:term"] || [];
    const categories = terms[0] || [];
    return categories[0]?.name || "";
  }

  function scrollToNewPosts(firstNewPostElement) {
    if (!firstNewPostElement) {
      return;
    }

    const fixedHeader = document.querySelector("header");
    const headerOffset = fixedHeader
      ? fixedHeader.getBoundingClientRect().height
      : 0;
    const extraOffset = 16;
    const targetY =
      window.scrollY +
      firstNewPostElement.getBoundingClientRect().top -
      headerOffset -
      extraOffset;

    window.scrollTo({
      top: Math.max(targetY, 0),
      behavior: "smooth",
    });
  }

  async function loadPostsFromAuthor() {
    if (hasLoadedAllPosts) {
      return;
    }

    let firstNewPostElement = null;

    try {
      const response = await fetch(
        `https://promotioncentre.co.uk/wp-json/wp/v2/posts?per_page=${postsPerPage}&page=${currentPage}&exclude=${excludedPosts.join(
          ","
        )}&author=${authorId}&_embed=1`
      );
      const total_pages = parseInt(response.headers.get("X-WP-TotalPages"), 10);
      const data = await response.json();

      await Promise.all(
        data.map(async (post) => {
        const aElement = document.createElement("a");
        aElement.classList.add(
          "relative",
          "overflow-hidden",
          "block",
          "font-light",
          "text-black",
          "no-underline",
          "article"
        );
        aElement.href = post.link;

        const categoryName = getEmbeddedCategoryName(post);
        if (categoryName) {
          const categorySpan = document.createElement("span");
          categorySpan.classList.add(
            "absolute",
            "top-0",
            "right-0",
            "z-40",
            "px-2",
            "py-1",
            "text-sm",
            "text-white",
            "rounded-tr-lg",
            "rounded-bl-lg",
            "bg-secondary"
          );
          categorySpan.textContent = categoryName;
          aElement.appendChild(categorySpan);
        }

        const h3Element = document.createElement("h3");
        h3Element.classList.add(
          "my-2",
          "text-xl",
          "lg:text-2xl",
          "leading-normal",
          "normal-case",
          "font-buenosaires"
        );

        const decodedTitle = decodeEntities(post.title.rendered);
        h3Element.textContent = decodedTitle;

        const excerptDiv = document.createElement("div");
        excerptDiv.classList.add("mt-2");
        excerptDiv.innerHTML = post.excerpt.rendered || "";

        const thumbnailUrl = getEmbeddedImageUrl(post);
        if (thumbnailUrl) {
          const outerDiv = document.createElement("div");
          outerDiv.classList.add(
            "relative", "flex", "items-center", "justify-center",
            "w-full", "mb-3", "overflow-hidden", "rounded-lg", "group",
            "after:w-full", "hover:lg:after:h-full",
            "after:transition-all", "after:ease-in-out", "after:duration-500",
            "after:h-0", "after:opacity-0", "hover:lg:after:opacity-60",
            "after:pointer-events-none", "after:absolute", "after:top-0",
            "after:bg-black", "after:z-30", "after:left-0"
          );

          const readLabel = document.createElement("p");
          readLabel.classList.add(
            "absolute", "z-50", "mb-0", "text-sm", "tracking-widest",
            "text-white", "uppercase", "transition-all", "duration-500",
            "ease-in-out", "transform", "-translate-x-1/2", "-translate-y-1/2",
            "opacity-0", "top-1/2", "left-1/2",
            "group-hover:lg:delay-200", "group-hover:lg:opacity-100"
          );
          readLabel.textContent = "Read article";

          const innerDiv = document.createElement("div");
          innerDiv.classList.add(
            "relative", "flex", "z-20", "w-full", "justify-center",
            "items-center", "overflow-hidden", "img-overlay", "pb-[50%]", "group"
          );

          const imgElement = document.createElement("img");
          imgElement.src = thumbnailUrl;
          imgElement.classList.add(
            "w-full", "!transition-all", "!ease-in-out", "!duration-500",
            "mb-4", "group-hover:lg:scale-110", "transform",
            "absolute", "top-0", "h-full", "object-cover", "object-center"
          );

          innerDiv.appendChild(imgElement);
          outerDiv.appendChild(readLabel);
          outerDiv.appendChild(innerDiv);
          aElement.appendChild(outerDiv);
        }

        aElement.appendChild(h3Element);
        aElement.appendChild(excerptDiv);
        if (!firstNewPostElement) {
          firstNewPostElement = aElement;
        }
        postContainerAuthor.appendChild(aElement);
        })
      );

      if (currentPage >= total_pages) {
        readMoreBtn.style.display = "none";
        hasLoadedAllPosts = true;
      } else {
        currentPage++;
      }
    } catch (error) {
      console.error(error);
    } finally {
      scrollToNewPosts(firstNewPostElement);
    }
  }

  if (postContainerAuthor) {
    loadPostsFromAuthor();
  }

  if (postContainerAuthor && readMoreBtn) {
    readMoreBtn.addEventListener("click", () => {
      loadPostsFromAuthor();
    });
  }
}
